export default "__VITE_ASSET__54b5db56__"